import React, { Component } from 'react';
import _ from 'lodash';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import '@mescius/wijmo.styles/wijmo.css';
import { FlexGrid } from '@mescius/wijmo.react.grid';
import { CollectionView } from '@mescius/wijmo';
import * as wjCore from '@mescius/wijmo';
import * as wjGrid from '@mescius/wijmo.grid';
import '@mescius/wijmo.cultures/wijmo.culture.ja';
import { Tooltip, PopupPosition } from '@mescius/wijmo';

import { CloseEditView } from '../components/CloseEditView';
import { HeaderMenu } from '../components/ProgressBase';
import { Confirmation } from '../components/modals/common';
import { ProgressWorkDatesDialog } from '../components/modals/ProgressWorkDatesDialog';
import { MasterPageHeader } from '../components/PageHeader';
import ProgressService from '../services/Progress';
import SessionStorageService from '../services/utilities/SessionStorageService';
import {
  SCHEDULE_EDIT_COLUMN_NAME,
  COLUMN_DISPLAY_MAIN_FLAG,
  COLUMN_DISPLAY_SUB_FLAG,
  COLUMN_EDIT_PERMISSION,
  COLUMN_NUMBER,
  TOOLTIP_WARNING,
  DATA_TYPE,
  PATTERN_NUMBER,
  setMathRoundNumber,
  setDisplayTab,
  setStyleForCell,
  setIconArrowForCell,
  setFormatData,
  getValidFormatDate,
  setNewDataType,
  setMaxHeightTable,
  KEY_GROUP_OF_WORK_TYPE,
  KEY_GROUP_OF_PLACE_TYPE,
  MAX_NUMBER_VALIDATOR,
  MAX_NUMBER_VALIDATOR_PRODUCTIVITY,
  isExistSubItem,
  initColumnGroupByTab,
} from '../utilities/constWijmo';
import {
  DATE_TIME_FORMAT,
  INDEX_OF_GRID_COLUMN,
  STATUS_CODE,
  FIRST_ROW_OF_TABLE,
  PADDING_TO_LEFT_RIGHT,
  LIST_COLUMN_RESIZE,
  FONT_SIZE,
  IS_DISABLE_ROW,
  EXIST_MAIN_SUB_WORK,
  PROGRESS_REQUEST_PARAMS,
  TITLE_BROWSER_PROGRESS,
  HEADER_CONSTANTS_PROGRESS,
} from '../utilities/constants';
import _dialogLoader from '../utilities/dialogLoader';
import { messageUtility } from '../utilities/messageUtility';
import { isNullOrEmpty } from '../utilities/stringUtil';
import IconProgress from '../images/icon-progress.svg';

export class ProgressScheduleEdit extends Component {
  constructor(props) {
    super(props);
    this.fieldId = SessionStorageService.getFieldId();
    this.date = new Date(
      new Date().toLocaleString('en-US', { timeZone: 'Asia/Tokyo' })
    );
    this.formatDate = moment(this.date).format(
      DATE_TIME_FORMAT.slashDateFormat
    );
    this.itemIds = SessionStorageService.getItemIds();
    this.tooltip = new Tooltip({
      showAtMouse: true,
      showDelay: 500,
      isContentHtml: false,
      cssClass: 'wj-tooltip-progress',
    });
    this.state = {
      isTableLoading: true,
      progressSchedule: [],
      countTotalInvalidCell: 0,
      isShowPopupError: false,
      messageError: '',
      isShowWorkDatesDialog: false,
      callApiFlag: false,
      currentProgressSchedule: null,
      totalHoliday: null,
      notificationList: [],
      apiStartedAt: null,
      startDate: null,
      endDate: null,
      listCellEdited: [],
      dataTypesUnregistered: [],
      params_schedule: {
        axis_type: SessionStorageService.getAxisType(),
        object_ids: JSON.parse(this.itemIds),
        offset: PROGRESS_REQUEST_PARAMS.offset,
        limit: PROGRESS_REQUEST_PARAMS.parentLimit,
        is_limit: PROGRESS_REQUEST_PARAMS.isLimit,
      },
      params_id: {
        last_field_main_work_type_id: null,
        last_field_sub_work_type_id: null,
        last_a_item_id: null,
        last_b_item_id: null,
        last_c_item_id: null,
        last_d_item_id: null,
      },
      isWorkType: _.isEqual(
        Number(SessionStorageService.getAxisType()),
        DATA_TYPE[0]
      ),
      total: null,
      newListItems: [],
      currentMainWorkIds: [],
      workTypeId: Number(SessionStorageService.getAxisType()),
      isCellEditing: false,
    };
    this.events = {
      dialog: {
        goBack: this.handleGoBackDialog,
      },
    };
    this.GoBack = {
      callback: {
        close: () => {
          _dialogLoader.close();
        },
        clear: () => {
          window.location.replace('/progress/0/0/0/ProgressSchedule:1/0:0');
        },
      },
    };
    this.childItemsPath = ['child', 'child', 'child', 'child', 'child'];
    this.isSubmitingFlag = false;
    this.isGetScheduleCalendar = false;
    this.startDateOldValue = null;
    this.endDateOldValue = null;
    this.isFocusFirstEdit = true;
    this.resetValue = null;
    this.listColumnResize = [];
    this.gridSelectionFlag = true;
    this.listProgressSchedulesAxis = null;
    this.isFirstMount = true;
    this.isClickBtnCalendar = false;
    this.isCopiedCellFlg = false;
    this.lastItemEdited = null;
    this.lastRowEdited = null;
    this.lastColEdited = null;
    this.isPlanTagFlg = parseInt(SessionStorageService.getIsPlanTabFlg());
    this.isProgressFlg = parseInt(SessionStorageService.getUseProgressFlag());
    this.strongNotification = SessionStorageService.getStrongtNotificationCount();
    this.listItems = new CollectionView([], { getError: this.validator });
    this.columnGroupInit = initColumnGroupByTab(
      SCHEDULE_EDIT_COLUMN_NAME,
      this.isPlanTagFlg
    );
    this.temporaryListItems = [];
  }

  async componentDidMount() {
    if (!this.isProgressFlg) {
      return window.location.replace('/error-permission');
    }
    await this.getFieldSettings();
    await this.getSchedulesWorkTypeAxis();
  }

  getSchedulesWorkTypeAxis = async () => {
    let params_id = _.cloneDeep(this.state.params_id);
    let params_schedule = _.cloneDeep(this.state.params_schedule);
    if (this.state.apiStartedAt) {
      params_schedule.call_api_started_at = this.state.apiStartedAt;
      params_schedule = { ...params_schedule, ...this.state.params_id };
    }
    _.forEach(params_schedule.object_ids, (id, index) => {
      if (_.isNull(id)) {
        params_schedule.object_ids[index] = '';
      }
    });
    const response = await ProgressService.getProgressSchedulesAxisByWorkType(
      this.fieldId,
      params_schedule
    );
    let data = _.get(response, 'data.entities.progress_schedules');
    const dataTypesUnregistered = _.get(
      response,
      'data.entities.data_types_unregistered'
    );
    if (!_.isEmpty(dataTypesUnregistered)) {
      data = setFormatData(dataTypesUnregistered, data, this.state.workTypeId);
    }
    if (_.get(response, 'data.entities.call_api_started_at')) {
      this.setState({
        apiStartedAt: _.get(response, 'data.entities.call_api_started_at'),
      });
    }
    params_id.last_field_main_work_type_id = _.get(
      response,
      'data.entities.last_field_main_work_type_id'
    );
    params_id.last_field_sub_work_type_id = _.get(
      response,
      'data.entities.last_field_sub_work_type_id'
    );
    params_id.last_a_item_id = _.get(response, 'data.entities.last_a_item_id');
    params_id.last_b_item_id = _.get(response, 'data.entities.last_b_item_id');
    params_id.last_c_item_id = _.get(response, 'data.entities.last_c_item_id');
    params_id.last_d_item_id = _.get(response, 'data.entities.last_d_item_id');
    if (response.result) {
      if (_.isEmpty(data)) {
        return this.setState({
          isShowPopupError: true,
          messageError:
            '他のユーザーが更新を行ったため更新することができません',
          isTableLoading: false,
        });
      }
      this.listProgressSchedulesAxis = _.get(
        response,
        'data.entities.progress_schedules'
      );

      if (this.isFirstMount) {
        this.temporaryListItems = data;
        return this.setState(
          {
            params_id,
            total: _.get(response, 'data.total'),
            dataTypesUnregistered,
          },
          this.handleAddNewData
        );
      } else {
        return this.setState(
          {
            newListItems: data,
            params_id,
            total: _.get(response, 'data.total'),
          },
          this.handleAddNewData
        );
      }
    }
  };

  getFieldSettings = async () => {
    const response = await ProgressService.getProgressFieldSettings(
      this.fieldId
    );
    if (response.result) {
      const data = _.get(response, 'data.entities.progress_field_settings');
      const startDate = _.get(data, 'input_start_date');
      const endDate = _.get(data, 'input_end_date');
      if (data) {
        this.setState({
          startDate,
          endDate,
        });
      }
    }
  };

  handleAddNewData = () => {
    const { total, isWorkType } = this.state;
    const params_schedule = _.cloneDeep(this.state.params_schedule);
    params_schedule.offset += PROGRESS_REQUEST_PARAMS.parentLimit;
    if (!this.isFirstMount) {
      const lastChildItem = _.last(this.temporaryListItems);
      const firstChildItem = _.first(this.state.newListItems);
      const otherNewListItems = _.filter(
        this.state.newListItems,
        item =>
          !_.isEqual(
            item[isWorkType ? 'field_main_work_type_id' : 'place_id'],
            firstChildItem[isWorkType ? 'field_main_work_type_id' : 'place_id']
          )
      );
      if (
        _.isEqual(
          lastChildItem[isWorkType ? 'field_main_work_type_id' : 'place_id'],
          firstChildItem[isWorkType ? 'field_main_work_type_id' : 'place_id']
        )
      ) {
        this.handleRecursiveData(
          lastChildItem,
          firstChildItem,
          isWorkType ? KEY_GROUP_OF_WORK_TYPE : KEY_GROUP_OF_PLACE_TYPE
        );
        this.setDataTable(otherNewListItems, params_schedule, total);
      } else {
        this.setDataTable(this.state.newListItems, params_schedule, total);
      }
    } else {
      this.setDataTable(this.state.newListItems, params_schedule, total);
    }
    if (params_schedule.offset >= total) {
      return;
    }
    this.isFirstMount = false;
    this.setState(
      {
        params_schedule,
      },
      () => {
        this.getSchedulesWorkTypeAxis();
      }
    );
  };

  handleRecursiveData = (lastItem, firstNewItem, keyGroup) => {
    if (_.includes(this.state.dataTypesUnregistered, DATA_TYPE[1])) {
      _.remove(keyGroup, key => _.isEqual(key, 'field_sub_work_type_id'));
    }
    const lastChildItem = _.last(lastItem.child);
    const firstChildItem = _.first(firstNewItem.child);
    const otherItems = _.filter(
      firstNewItem.child,
      item => !_.isEqual(item[keyGroup[0]], firstChildItem[keyGroup[0]])
    );
    if (
      !_.isUndefined(lastChildItem) &&
      _.isEqual(lastChildItem[keyGroup[0]], firstChildItem[keyGroup[0]])
    ) {
      lastItem.child = _.concat(lastItem.child, otherItems);
      this.handleRecursiveData(lastChildItem, firstChildItem, _.drop(keyGroup));
    } else {
      lastItem.child = _.concat(lastItem.child, firstNewItem.child);
    }
  };

  handleValidateItem = (
    item,
    prop,
    displayName,
    validationConfig,
    isMaxDate = false,
    isMinDate = false
  ) => {
    const validators = validationConfig[prop];
    if (!validators) {
      return '';
    }
    const value = item[prop];
    for (let i = 0; i < validators.length; i++) {
      let validationError = null;
      if (isMaxDate && validators[i].isMaxDate) {
        validationError = validators[i].validate(value, item['end_date']);
      } else if (isMinDate && validators[i].isMinDate) {
        validationError = validators[i].validate(value, item['start_date']);
      } else {
        validationError = validators[i].validate(displayName, value);
      }
      if (!wjCore.isNullOrWhiteSpace(validationError)) {
        return validationError;
      }
    }
  };

  calculateCurrentWorkDay = (startDate, holiday) => {
    const diffTime = new Date(this.formatDate) - new Date(startDate);
    let diffDays = 0;
    if (diffTime >= 0) {
      diffDays = getDaysDiff(startDate, this.formatDate);
    }
    const currentWorkDays = diffDays - holiday;
    return currentWorkDays;
  };

  getProgressScheduleCalendars = async rowData => {
    if (this.isGetScheduleCalendar) {
      return;
    }
    this.isGetScheduleCalendar = true;
    const { start_date, end_date, id: progress_schedule_id } = rowData;
    if (!_.isNull(start_date) && !_.isNull(end_date)) {
      const response = await ProgressService.getProgressScheduleCalendars(
        this.fieldId,
        {
          start_date,
          end_date,
          progress_schedule_id,
        }
      );
      if (_.get(response, 'result')) {
        this.isGetScheduleCalendar = false;
        return response;
      } else {
        if (_.isEqual(response.status, STATUS_CODE.badRequest)) {
          this.isGetScheduleCalendar = false;
          this.setState({
            isShowPopupError: true,
            messageError: messageUtility.getMessage('I-001-506'),
          });
        }
      }
    }
  };

  getScheduleCalendarAndDetail = async (rowData, row) => {
    const { start_date, end_date } = rowData;
    const response = await this.getProgressScheduleCalendars(rowData);
    if (_.get(response, 'result')) {
      const holiday = _.get(response, 'data.entities.work_dates');
      const progressScheduleCalendars = this.handleProgressScheduleCalendars(
        holiday,
        rowData
      );
      const workDays =
        getDaysDiff(start_date, end_date) - _.size(progressScheduleCalendars);
      this.flexGrid.setCellData(row, 'plan_work_days', workDays);
      rowData.progress_schedule_calendars = progressScheduleCalendars;
      const listHoliday = this.getHolidayFromStartToToday(
        progressScheduleCalendars
      );
      rowData.current_work_days = this.calculateCurrentWorkDay(
        start_date,
        listHoliday
      );
      rowData.holiday = progressScheduleCalendars;
      rowData.mans_per_day = this.calculateEditableColumn(
        rowData.total_man_days,
        rowData.plan_work_days
      );
      if (this.isClickBtnCalendar) {
        this.handleOpenCalendar(
          this.lastItemEdited,
          this.lastRowEdited,
          this.lastColEdited
        );
      }
    }
  };

  updateProgressSchedules = async () => {
    const progressSchedule = this.handleParams(this.state.progressSchedule);
    if (this.isSubmitingFlag) {
      return;
    }
    this.isSubmitingFlag = true;
    const response = await ProgressService.updateProgressSchedulesBulkUpdate(
      this.fieldId,
      { progress_schedules: progressSchedule }
    );
    this.isSubmitingFlag = false;
    if (response.result) {
      window.location.replace('/progress/0/0/0/ProgressSchedule:1/0:0');
    } else {
      const message =
        _.get(response, 'data.message') ||
        messageUtility.getMessage('E-000-001');
      this.setState({
        isShowPopupError: true,
        messageError: message,
      });
    }
  };

  getWorkDays = (item, calendars) => {
    let { start_date, end_date, rowNumber } = item;
    const diffDays = getDaysDiff(start_date, end_date);
    const workDays = diffDays - _.size(calendars);
    const listHoliday = this.getHolidayFromStartToToday(calendars);
    this.flexGrid.setCellData(
      rowNumber,
      INDEX_OF_GRID_COLUMN.plan_work_days,
      workDays
    );
    item.progress_schedule_calendars = calendars;
    item.current_work_days = this.calculateCurrentWorkDay(
      start_date,
      listHoliday
    );
    item.holiday = calendars;
    item.mans_per_day = this.calculateEditableColumn(
      item.total_man_days,
      workDays
    );
    const progressSchedule = this.getProgressScheduleItem(item);
    const dataUpdate = this.flexGrid.rows[rowNumber].dataItem;
    dataUpdate.current_work_days = item.current_work_days;
    dataUpdate.holiday = calendars;
    dataUpdate.progress_schedule_calendars = calendars;
    dataUpdate.mans_per_day = item.mans_per_day;
    this.setState({ progressSchedule }, () => {
      this.calculateWhenEditEnded(this.flexGrid);
      this.flexGrid.focus();
      this.isClickBtnCalendar = false;
    });
  };

  getHolidayFromStartToToday = listHoliday => {
    let totalHoliday = 0;
    _.forEach(listHoliday, item => {
      if (
        moment(item.target_date).isBefore(this.formatDate) ||
        moment(item.target_date).isSame(this.formatDate)
      ) {
        totalHoliday += 1;
      }
    });
    return totalHoliday;
  };

  getProgressScheduleItem = item => {
    const progressSchedule = _.cloneDeep(this.state.progressSchedule);
    const index = _.findIndex(
      progressSchedule,
      itemProgress => itemProgress.id === item.id
    );
    if (index < 0) {
      progressSchedule.push(item);
    } else {
      progressSchedule[index] = item;
    }
    return progressSchedule;
  };

  recursiveAddParamsForItems = (listItems, listParentsId, type) => {
    _.forEach(listItems, item => {
      let parentsId = [];
      let typeItem = null;
      if (listParentsId) {
        parentsId = [...listParentsId];
        if (_.isEqual(type, item.data_type)) {
          parentsId.pop();
        }
      }
      if (parentsId) {
        item.parentsId = parentsId;
      }
      if (item.child) {
        if (_.isEqual(item.data_type, DATA_TYPE[0])) {
          parentsId = [...parentsId, item.field_main_work_type_id];
        } else if (_.isEqual(item.data_type, DATA_TYPE[1])) {
          parentsId = [...parentsId, item.field_sub_work_type_id];
        } else {
          parentsId = [...parentsId, item.place_id];
        }
      }
      typeItem = item.data_type;
      if (_.isEmpty(item.child) || _.isUndefined(item.child)) {
        item.holiday = [];
        item.isMaxDate = false;
        item.isMinDate = false;
        item.oldValueOfStartDate = item.start_date;
        item.oldValueOfEndDate = item.end_date;
        item.oldValueOfQuantity = item.quantity;
        item.oldValueOfProductivity = item.productivity;
        item.oldValueOfTotalManDays = item.total_man_days;
        item.oldValueOfResultEndDate = item.result_end_date;
        item.oldValueOfResultAmount = item.result_amount;
        item.oldValueOfPlanWorkDays = item.plan_work_days;
        item.isPlanWorkDaysEdited = false;
      } else {
        this.recursiveAddParamsForItems(item.child, parentsId, typeItem);
      }
    });
  };

  setDataTable = (newItems, params_schedule, total) => {
    this.temporaryListItems = _.concat(this.temporaryListItems, newItems);
    if (params_schedule.offset >= total) {
      this.listItems.sourceCollection = this.temporaryListItems;
      this.listItems.refresh();
      this.setFormatCellTable();
      this.setState({
        isTableLoading: false,
      });
    }
  };

  validator = (item, prop) => {
    let isEditRow = false;
    if (_.isEmpty(item.child) || _.isUndefined(item.child)) {
      isEditRow = true;
    }
    let validationConfig = {
      start_date: [new MaxValueDateValidator()],
      end_date: [new MinValueDateValidator()],
      quantity: [
        new MaxNumberValidator(
          MAX_NUMBER_VALIDATOR,
          '0から整数6桁小数点以下2桁までを入力してください。'
        ),
      ],
      productivity: [],
      total_man_days: [],
      result_amount: [
        new MaxNumberValidator(
          MAX_NUMBER_VALIDATOR,
          '0から整数6桁小数点以下2桁までを入力してください。'
        ),
      ],
    };
    if (item.man_day_input_flag) {
      validationConfig.total_man_days = [
        new MaxNumberValidator(
          MAX_NUMBER_VALIDATOR,
          '0から整数6桁小数点以下2桁までを入力してください。',
          'n*'
        ),
      ];
    } else {
      validationConfig.productivity = [
        new MaxNumberValidator(
          MAX_NUMBER_VALIDATOR_PRODUCTIVITY,
          '0から整数3桁小数点以下2桁までを入力してください。',
          'n*'
        ),
      ];
    }
    const displayName = this.flexGrid.columns.getColumn(prop).header;
    return isEditRow
      ? this.handleValidateItem(
          item,
          prop,
          displayName,
          validationConfig,
          item.isMaxDate,
          item.isMinDate
        )
      : null;
  };

  setFormatCellTable = () => {
    const { isWorkType, workTypeId } = this.state;
    if (this.flexGrid.collectionView) {
      this.recursiveAddParamsForItems(this.flexGrid.collectionView.items);
    }
    let rowEditFirst;
    let currentRow = 0;
    _.forEach(this.flexGrid.rows, row => {
      row.visible = !row._data.is_null;
      if (
        !isWorkType &&
        _.isEqual(row._data.data_type, DATA_TYPE[workTypeId + 1])
      ) {
        row.visible = true;
      }
      for (const [key, value] of Object.entries(row._data)) {
        if (_.includes(COLUMN_NUMBER, key) && !_.isNull(row._data[key])) {
          row._data[key] = setMathRoundNumber(value);
        }
        if (this.isFocusFirstEdit && _.isEmpty(row._data.child)) {
          rowEditFirst = currentRow;
          this.isFocusFirstEdit = false;
        }
      }
      currentRow++;
      setStyleForCell(row, isWorkType, workTypeId);
    });
    _.forEach(this.flexGrid.columns, column => {
      const classEdit = 'wj-col-editable';
      if (!_.includes(COLUMN_EDIT_PERMISSION, column.binding)) {
        column.isReadOnly = true;
      } else {
        column._cssClass = classEdit;
      }
    });
    this.flexGrid.select(
      new wjGrid.CellRange(
        rowEditFirst,
        !this.isPlanTagFlg
          ? INDEX_OF_GRID_COLUMN.start_date
          : INDEX_OF_GRID_COLUMN.result_end_date
      ),
      false
    );
    this.flexGrid.focus();
    this.flexGrid.autoSizeColumns();
  };

  setDataDate = (startDate, planWorkDays, currentWorkDays, result) => {
    const percent = Math.round((currentWorkDays / planWorkDays) * 100);
    let textHtml = `${currentWorkDays}日 (${percent}%)`;
    if (moment(startDate).isAfter(this.formatDate)) {
      textHtml = `0日 (${percent}%)`;
    }
    if (moment(startDate).isBefore(this.formatDate) && percent > 100) {
      textHtml = `${currentWorkDays}日 (<span class="text--negative">${percent}%</span>)`;
    }
    result.innerHTML = textHtml;
  };

  setIsReadOnlyColumn = grid => {
    const item = grid.selectedItems[0];
    if (item) {
      const flag = item.man_day_input_flag;
      grid.columns[INDEX_OF_GRID_COLUMN.start_date].isReadOnly = false;
      grid.columns[INDEX_OF_GRID_COLUMN.end_date].isReadOnly = false;
      grid.columns[INDEX_OF_GRID_COLUMN.quantity].isReadOnly = false;
      grid.columns[INDEX_OF_GRID_COLUMN.productivity].isReadOnly = flag;
      grid.columns[INDEX_OF_GRID_COLUMN.total_man_days].isReadOnly = !flag;
      grid.columns[INDEX_OF_GRID_COLUMN.result_end_date].isReadOnly = false;
      grid.columns[INDEX_OF_GRID_COLUMN.result_amount].isReadOnly = false;
    }
  };

  setNewTooltip = (domCell, text) => {
    this.tooltip.setTooltip(domCell, text, PopupPosition.Right);
  };

  setBackgroundCell = (domCell, rowData) => {
    const { data_type, child } = rowData;
    const { isWorkType, workTypeId } = this.state;
    const dataType = setNewDataType(workTypeId);
    if (_.isEqual(data_type, dataType[0])) {
      domCell.classList = _.isEmpty(child)
        ? 'wj-cell wj-group wj-bg-default wj-border-solid wj-align-right wj-edit-permission'
        : 'wj-cell wj-group wj-bg-default wj-border-solid wj-align-right';
    } else if (
      _.isEqual(data_type, dataType[1]) ||
      (!isWorkType && _.isEqual(data_type, dataType[2]))
    ) {
      domCell.classList = _.isEmpty(child)
        ? 'wj-cell wj-group wj-bg-gray wj-border-dotted wj-align-right wj-edit-permission'
        : 'wj-cell wj-group wj-bg-gray wj-border-dotted wj-align-right';
    } else {
      domCell.classList =
        'wj-cell wj-group wj-alt wj-bg-white wj-border-dotted wj-align-right wj-edit-permission';
    }
    if (_.isEqual(this.flexGrid.activeCell, domCell)) {
      domCell.classList += ' wj-state-active wj-state-selected';
    }
  };

  setBackgroundCellEdited = (domCell, oldValue, value, col, row) => {
    const numberOfColRow = _.toNumber(`${col}${row}`);
    const findId = _.find(this.state.listCellEdited, item => {
      return item.id === numberOfColRow;
    });
    if (!_.isUndefined(findId)) {
      if (!_.isEqual(oldValue, value)) {
        this.setState(prevState => ({
          listCellEdited: [
            ..._.map(prevState.listCellEdited, cell => {
              return cell.id !== numberOfColRow
                ? cell
                : {
                    ...cell,
                    isEdited: true,
                  };
            }),
          ],
        }));
      }
      if (findId.isEdited) {
        domCell.classList += ' wj-cell-edited';
      }
    }
  };

  setMaxHeightGrid = () => {
    const divFixed = document.querySelector('.ProgressSchedule .wj-flexgrid');
    if (divFixed) {
      const params = {
        heightOfTable: 'calc(100vh - 175px)',
        heightOfTableHaveNoti: 'calc(100vh - 215px)',
        heghtOfTableIpad: 'calc(100vh - 270px)',
        heightOfTableIpadHaveNoti: 'calc(100vh - 305px)',
      };
      setMaxHeightTable(divFixed, params);
    }
  };

  handleWarningInputDate = (domCell, input) => {
    const { startDate, endDate } = this.state;
    if (
      !_.isNull(input) &&
      !_.isNull(startDate) &&
      (moment(input).isBefore(startDate) || moment(input).isAfter(endDate))
    ) {
      domCell.classList.add('wj-warning');
      this.setNewTooltip(domCell, TOOLTIP_WARNING);
    }
  };

  handleGoBackDialog = () => {
    _dialogLoader.show(CloseEditView, this.GoBack);
  };

  handleAddUnitName = (domCell, unit) => {
    const unitDom = document.createElement('span');
    unitDom.textContent = `${unit}`;
    unitDom.classList.add('unit');
    domCell.appendChild(unitDom);
  };

  handleAddIconInputDate = domCell => {
    if (
      _.size(domCell.childNodes) < 2 &&
      domCell.classList.contains('wj-row-editable') &&
      ((!_.isNull(domCell.lastChild) && domCell.lastChild.type !== 'button') ||
        _.isNull(domCell.lastChild))
    ) {
      const button = document.createElement('button');
      button.className = 'wj-btn wj-btn-glyph wj-right wj-elem-dropdown';
      const span = document.createElement('span');
      span.className = 'wj-glyph-down';
      button.appendChild(span);
      domCell.appendChild(button);
    }
  };

  handleDisplayUnitName = (
    rowData,
    key,
    isWorkType,
    workTypeId,
    unit,
    flag
  ) => {
    let unit_name = unit;
    if (_.isNull(rowData[key])) {
      unit_name = `--${unit}`;
      if (
        (_.isEqual(rowData.data_type, DATA_TYPE[0]) &&
          !_.isEmpty(rowData.child) &&
          isExistSubItem(this.state.dataTypesUnregistered, rowData) &&
          _.includes(COLUMN_DISPLAY_MAIN_FLAG, key)) ||
        (!_.isEmpty(rowData.child) &&
          _.includes(COLUMN_DISPLAY_SUB_FLAG, key)) ||
        (!isWorkType &&
          _.isEqual(rowData.data_type, DATA_TYPE[workTypeId + 1]) &&
          _.includes(COLUMN_DISPLAY_MAIN_FLAG, key))
      ) {
        unit_name = '';
      }
      if (
        (_.isEmpty(rowData.child) || _.isUndefined(rowData.child)) &&
        _.includes(COLUMN_EDIT_PERMISSION, key)
      ) {
        unit_name = unit;
        if (flag) {
          unit_name = `--${unit}`;
        }
      }
    }
    return unit_name;
  };

  formatNumber = data => {
    const formatType = new Intl.NumberFormat('en-US');
    return !_.isNull(data) ? formatType.format(data) : '';
  };

  handleChangeColorText = (cell, value) => {
    const result = setMathRoundNumber(value);
    if (Number(value) > 0) {
      cell.classList += ' wj-text-green';
      cell.textContent = `+${this.formatNumber(value)}`;
    }
    cell.classList += Number(result) < 0 ? ' wj-text-red' : '';
  };

  handleOpenCalendar = async (rowData, row, col) => {
    const {
      start_date,
      end_date,
      progress_schedule_calendars,
      id,
      oldValueOfStartDate,
      oldValueOfEndDate,
    } = rowData;
    if (moment(end_date).isBefore(start_date)) {
      return;
    }
    let progressScheduleCalendars = [];
    let holiday = progress_schedule_calendars;
    const response = await this.getProgressScheduleCalendars(rowData);
    if (_.get(response, 'result')) {
      const savedHoliday = _.get(response, 'data.entities.work_dates');
      progressScheduleCalendars = this.handleProgressScheduleCalendars(
        savedHoliday,
        rowData
      );
      if (!_.isUndefined(holiday)) {
        holiday = _.remove(holiday, item => {
          return (
            moment(item.target_date).isSameOrAfter(start_date) &&
            moment(item.target_date).isSameOrBefore(end_date)
          );
        });
        const temporaryHoliday = [];
        _.forEach(savedHoliday, item => {
          if (
            oldValueOfStartDate &&
            oldValueOfEndDate &&
            (moment(item.target_date).isBefore(oldValueOfStartDate) ||
              moment(item.target_date).isAfter(oldValueOfEndDate))
          ) {
            temporaryHoliday.push(item);
          }
        });
        progressScheduleCalendars = _.uniqBy(
          _.concat(holiday, temporaryHoliday),
          'target_date'
        );
      }
      const currentProgressSchedule =
        _.find(this.state.progressSchedule, item => _.isEqual(item.id, id)) ||
        rowData;
      if (currentProgressSchedule) {
        currentProgressSchedule.rowNumber = row;
        currentProgressSchedule.colNumber = col;
        currentProgressSchedule.progress_schedule_calendars = progressScheduleCalendars;
      }
      const progressSchedule = this.getProgressScheduleItem(
        currentProgressSchedule
      );
      this.setState({
        callApiFlag: _.isUndefined(
          _.get(currentProgressSchedule, 'progress_schedule_calendars')
        ),
        progressSchedule,
        currentProgressSchedule,
        isShowWorkDatesDialog: true,
      });
    }
  };

  handleParams = progressSchedule => {
    return _.map(progressSchedule, progressScheduleItem => {
      let {
        id,
        start_date,
        end_date,
        quantity,
        productivity,
        total_man_days,
        result_end_date,
        result_amount: result_quantity,
        progress_schedule_calendars,
        man_day_input_flag,
      } = progressScheduleItem;
      const item = {
        id,
        start_date,
        end_date,
        quantity,
        productivity,
        total_man_days,
        result_end_date,
        result_quantity,
        progress_schedule_calendars,
        man_day_input_flag,
      };
      return item;
    });
  };

  handleMouseEvent = (button, rowData, rowNumber, colNumber) => {
    button.addEventListener('mouseover', () => {
      this.isClickBtnCalendar = true;
      this.gridSelectionFlag = false;
    });
    button.addEventListener('mouseout', () => {
      this.isClickBtnCalendar = false;
      this.gridSelectionFlag = true;
    });
    button.addEventListener('click', () => {
      this.isClickBtnCalendar = true;
      this.handleOpenCalendar(rowData, rowNumber, colNumber);
    });
  };

  handleProgressScheduleCalendars = (savedHoliday, rowData) => {
    const { start_date, end_date, progress_schedule_calendars } = rowData;
    const progressScheduleCalendars = !_.isUndefined(
      progress_schedule_calendars
    )
      ? _.uniqBy(
          _.concat(_.get(rowData, 'progress_schedule_calendars'), savedHoliday),
          'target_date'
        )
      : savedHoliday;
    if (!_.isEmpty(progressScheduleCalendars)) {
      _.remove(progressScheduleCalendars, progressScheduleCalendar => {
        const { target_date } = progressScheduleCalendar;
        return (
          moment(target_date).isBefore(start_date) ||
          moment(target_date).isAfter(end_date)
        );
      });
    }
    return progressScheduleCalendars;
  };

  refreshed = ctl => {
    let countTotalInvalidCell = 0;
    const recursiveValidateData = (flexGrid, listItems) => {
      _.forEach(listItems, item => {
        if (_.isEmpty(item.child) || _.isUndefined(item.child)) {
          _.forEach(flexGrid.columns, col => {
            flexGrid.collectionView.getError(item, col.binding) &&
              ++countTotalInvalidCell;
          });
        } else {
          recursiveValidateData(flexGrid, item.child);
        }
      });
    };
    recursiveValidateData(ctl, ctl.collectionView.items);
    this.setState({
      countTotalInvalidCell,
    });
  };

  formatItem = (sender, formatItemEvent) => {
    const columnName = sender.columns[formatItemEvent.col].binding;
    const isPanelEqualCell = formatItemEvent.panel === sender.cells;
    const rowData = formatItemEvent.panel.rows[formatItemEvent.row]._data;
    const domCell = formatItemEvent.cell;
    const rowNumber = formatItemEvent.row;
    const colNumber = formatItemEvent.col;
    const { isWorkType, workTypeId } = this.state;

    if (isPanelEqualCell) {
      const {
        start_date,
        end_date,
        plan_work_days,
        current_work_days,
        result_end_date,
        quantity,
        productivity,
        unit_name,
        result_amount,
        plan_result_diff_amount,
        plan_result_diff_man_hours,
        plan_result_diff_productivity,
        sub_works_or_places,
        main_work_type_flag,
        sub_work_type_flag,
        man_day_input_flag,
        mans_per_day,
        work_places,
        total_man_days,
        oldValueOfStartDate,
        oldValueOfEndDate,
        oldValueOfQuantity,
        oldValueOfProductivity,
        oldValueOfTotalManDays,
        oldValueOfResultEndDate,
        oldValueOfResultAmount,
        oldValueOfPlanWorkDays,
      } = rowData;
      switch (columnName) {
        case 'start_date':
          if (!this.listItems.getError(rowData, columnName)) {
            this.handleWarningInputDate(domCell, start_date);
          }
          this.handleAddIconInputDate(domCell);
          this.setBackgroundCellEdited(
            domCell,
            oldValueOfStartDate,
            start_date,
            colNumber,
            rowNumber
          );
          break;
        case 'end_date':
          if (!this.listItems.getError(rowData, columnName)) {
            this.handleWarningInputDate(domCell, end_date);
          }
          this.handleAddIconInputDate(domCell);
          this.setBackgroundCellEdited(
            domCell,
            oldValueOfEndDate,
            end_date,
            colNumber,
            rowNumber
          );
          break;
        case 'name': {
          if (!_.isNull(domCell.lastChild)) {
            domCell.lastChild.textContent = '';
          } else {
            domCell.textContent = '';
          }
          const result = document.createElement('div');
          const text = document.createTextNode(
            _.isNull(rowData.name) ? 'ー' : rowData.name
          );
          setIconArrowForCell(isWorkType, workTypeId, domCell, rowData, result);
          result.appendChild(text);
          result.className = 'wj-overflow';
          domCell.appendChild(result);
          this.setNewTooltip(domCell, rowData.name);
          break;
        }
        case 'plan_work_days': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'plan_work_days',
            isWorkType,
            workTypeId,
            '日'
          );
          if (_.isEmpty(rowData.child)) {
            if (!start_date || !end_date) {
              if (!_.isEqual(oldValueOfPlanWorkDays, plan_work_days)) {
                rowData.isPlanWorkDaysEdited = true;
              }
              domCell.innerText = '--日';
            } else {
              if (moment(start_date).isAfter(moment(end_date))) {
                if (!_.isEqual(oldValueOfPlanWorkDays, plan_work_days)) {
                  rowData.isPlanWorkDaysEdited = true;
                }
                domCell.innerText = '--日';
              } else {
                if (_.isNull(plan_work_days)) {
                  rowData.isPlanWorkDaysEdited = true;
                } else {
                  let button = document.createElement('button');
                  button.innerHTML = '稼働日の変更';
                  button.classList = 'btn-text--sm';
                  this.handleMouseEvent(button, rowData, rowNumber, colNumber);
                  this.handleAddUnitName(domCell, unit);
                  if (!_.isEqual(oldValueOfPlanWorkDays, plan_work_days)) {
                    rowData.isPlanWorkDaysEdited = true;
                  }
                  domCell.classList += ' wj-work-days';
                  domCell.appendChild(button);
                }
              }
            }
            if (rowData.isPlanWorkDaysEdited) {
              domCell.classList += ' wj-cell-edited';
            }
          } else {
            return null;
          }
          break;
        }
        case 'quantity': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'quantity',
            isWorkType,
            workTypeId,
            ` ${unit_name}`
          );
          this.handleAddUnitName(domCell, unit);
          this.setBackgroundCellEdited(
            domCell,
            oldValueOfQuantity,
            quantity,
            colNumber,
            rowNumber
          );
          break;
        }
        case 'productivity': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'productivity',
            isWorkType,
            workTypeId,
            ` ${unit_name}/人`,
            man_day_input_flag
          );
          if (man_day_input_flag) {
            this.setBackgroundCell(domCell, rowData);
          }
          this.handleAddUnitName(domCell, unit);
          this.setBackgroundCellEdited(
            domCell,
            oldValueOfProductivity,
            productivity,
            colNumber,
            rowNumber
          );
          break;
        }
        case 'total_man_days': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'total_man_days',
            isWorkType,
            workTypeId,
            ' 人',
            !man_day_input_flag
          );
          if (!man_day_input_flag) {
            this.setBackgroundCell(domCell, rowData);
          }
          this.handleAddUnitName(domCell, unit);
          this.setBackgroundCellEdited(
            domCell,
            oldValueOfTotalManDays,
            total_man_days,
            colNumber,
            rowNumber
          );
          break;
        }
        case 'mans_per_day': {
          if (
            ((main_work_type_flag && !_.isEmpty(sub_works_or_places)) ||
              (sub_work_type_flag && !_.isEmpty(work_places))) &&
            _.isNull(mans_per_day)
          ) {
            return null;
          }
          const unit = this.handleDisplayUnitName(
            rowData,
            'mans_per_day',
            isWorkType,
            workTypeId,
            ' 人'
          );
          this.handleAddUnitName(domCell, unit);
          break;
        }
        case 'result_end_date':
          this.handleAddIconInputDate(domCell);
          this.setBackgroundCellEdited(
            domCell,
            oldValueOfResultEndDate,
            result_end_date,
            colNumber,
            rowNumber
          );
          break;
        case 'elapsed_days': {
          const result = document.createElement('div');
          result.classList.add('unit');
          if (!_.isEmpty(rowData.child)) {
            result.innerHTML = '';
          } else {
            if (start_date) {
              if (end_date) {
                if (result_end_date) {
                  const diffTime = Math.abs(
                    new Date(end_date) - new Date(result_end_date)
                  );
                  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                  if (moment(end_date).isSame(result_end_date)) {
                    result.innerHTML = '完了 (予定通り)';
                  } else if (moment(end_date).isAfter(result_end_date)) {
                    result.innerHTML = `完了 (<span class="text--effective">${diffDays}日前倒</span>)`;
                  } else {
                    result.innerHTML = `完了 (<span class="text--negative">${diffDays}日遅延</span>)`;
                  }
                } else {
                  if (plan_work_days && plan_work_days !== 0) {
                    this.setDataDate(
                      start_date,
                      plan_work_days,
                      current_work_days,
                      result
                    );
                  } else if (plan_work_days === 0) {
                    result.innerHTML = `${current_work_days}日 (--%)`;
                  } else {
                    result.innerHTML = '--日';
                  }
                }
              } else {
                if (result_end_date) {
                  result.innerHTML = '完了';
                } else {
                  if (plan_work_days && plan_work_days !== 0) {
                    this.setDataDate(
                      start_date,
                      plan_work_days,
                      current_work_days,
                      result
                    );
                  } else {
                    result.innerHTML = '--日';
                  }
                }
              }
            } else {
              result.innerHTML = '--日';
            }
          }
          domCell.textContent = '';
          domCell.appendChild(result);
          break;
        }
        case 'plan_man_hours': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'plan_man_hours',
            isWorkType,
            workTypeId,
            ' 人'
          );
          this.handleAddUnitName(domCell, unit);
          break;
        }
        case 'schedule_man_hours': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'schedule_man_hours',
            isWorkType,
            workTypeId,
            ' 人'
          );
          this.handleAddUnitName(domCell, unit);
          break;
        }
        case 'result_man_hours': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'result_man_hours',
            isWorkType,
            workTypeId,
            ' 人'
          );
          this.handleAddUnitName(domCell, unit);
          break;
        }
        case 'plan_result_diff_man_hours': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'plan_result_diff_man_hours',
            isWorkType,
            workTypeId,
            ' 人'
          );
          this.handleChangeColorText(domCell, plan_result_diff_man_hours);
          this.handleAddUnitName(domCell, unit);
          break;
        }
        case 'plan_amount': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'plan_amount',
            isWorkType,
            workTypeId,
            ` ${unit_name}`
          );
          this.handleAddUnitName(domCell, unit);
          break;
        }
        case 'result_amount': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'result_amount',
            isWorkType,
            workTypeId,
            ` ${unit_name}`
          );
          this.handleAddUnitName(domCell, unit);
          this.setBackgroundCellEdited(
            domCell,
            oldValueOfResultAmount,
            result_amount,
            colNumber,
            rowNumber
          );
          break;
        }
        case 'plan_result_diff_amount': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'plan_result_diff_amount',
            isWorkType,
            workTypeId,
            ` ${unit_name}`
          );
          this.handleChangeColorText(domCell, plan_result_diff_amount);
          this.handleAddUnitName(domCell, unit);
          break;
        }
        case 'plan_productivity': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'plan_productivity',
            isWorkType,
            workTypeId,
            ` ${unit_name}/人`
          );
          this.handleAddUnitName(domCell, unit);
          break;
        }
        case 'result_productivity': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'result_productivity',
            isWorkType,
            workTypeId,
            ` ${unit_name}/人`
          );
          this.handleAddUnitName(domCell, unit);
          break;
        }
        case 'plan_result_diff_productivity': {
          const unit = this.handleDisplayUnitName(
            rowData,
            'plan_result_diff_productivity',
            isWorkType,
            workTypeId,
            ` ${unit_name}/人`
          );
          this.handleChangeColorText(domCell, plan_result_diff_productivity);
          this.handleAddUnitName(domCell, unit);
          break;
        }
      }
    }
  };

  calculateEditableColumn = (a, b) => {
    let result = +a / +b;
    if (
      isNullOrEmpty(b) ||
      isNullOrEmpty(a) ||
      isNaN(a) ||
      isNaN(b) ||
      _.isEqual(+b, 0)
    ) {
      result = null;
    }
    return setMathRoundNumber(result);
  };

  calculateElapsedDays = (
    startDate,
    endDate,
    today,
    holiday,
    currentWorkDays
  ) => {
    let elapsedDays;
    if (isNullOrEmpty(startDate)) {
      elapsedDays = null;
    } else {
      if (moment(startDate).isAfter(today)) {
        elapsedDays = 0;
      }
      if (moment(endDate).isBefore(today)) {
        const diffDays = getDaysDiff(startDate, endDate);
        const holidayFromStartToToday = _.size(holiday);
        elapsedDays = diffDays - holidayFromStartToToday;
      }
      if (
        moment(startDate).isSameOrBefore(today) &&
        moment(endDate).isSameOrAfter(today)
      ) {
        elapsedDays = currentWorkDays;
      }
    }
    return elapsedDays;
  };

  calculatePlanManHours = (totalManDays, workDaysToCurrent, planWorkDays) => {
    let planManHours = +totalManDays * (+workDaysToCurrent / +planWorkDays);
    if (
      isNullOrEmpty(totalManDays) ||
      isNullOrEmpty(planWorkDays) ||
      isNullOrEmpty(workDaysToCurrent) ||
      isNaN(totalManDays) ||
      isNaN(workDaysToCurrent) ||
      isNaN(planWorkDays) ||
      _.isEqual(+planWorkDays, 0)
    ) {
      planManHours = null;
    }
    return setMathRoundNumber(planManHours);
  };

  calculatePlanResultDiffManHours = (resultManHours, planManHours) => {
    let planResultDiffManHours = +resultManHours - +planManHours;
    if (
      isNullOrEmpty(resultManHours) ||
      isNullOrEmpty(planManHours) ||
      isNaN(resultManHours) ||
      isNaN(planManHours)
    ) {
      planResultDiffManHours = null;
    }
    return setMathRoundNumber(planResultDiffManHours);
  };

  calculatePlanAmount = (workDaysToCurrent, planWorkDays, quantity) => {
    let planAmount = (+workDaysToCurrent / +planWorkDays) * +quantity;
    if (
      isNullOrEmpty(workDaysToCurrent) ||
      isNullOrEmpty(planWorkDays) ||
      isNullOrEmpty(quantity) ||
      isNaN(workDaysToCurrent) ||
      isNaN(planWorkDays) ||
      isNaN(quantity) ||
      _.isEqual(+planWorkDays, 0)
    ) {
      planAmount = null;
    }
    return setMathRoundNumber(planAmount);
  };

  calculatePlanResultDiffAmount = (resultAmount, planAmount) => {
    let planResultDiffAmount = +resultAmount - +planAmount;
    if (
      isNullOrEmpty(resultAmount) ||
      isNullOrEmpty(planAmount) ||
      isNaN(resultAmount) ||
      isNaN(planAmount)
    ) {
      planResultDiffAmount = null;
    }
    return setMathRoundNumber(planResultDiffAmount);
  };

  calculateResultProductivity = (resultAmount, resultManHours) => {
    let resultProductivity = +resultAmount / +resultManHours;
    if (
      isNullOrEmpty(resultAmount) ||
      isNullOrEmpty(resultManHours) ||
      isNaN(resultAmount) ||
      isNaN(resultManHours) ||
      _.isEqual(+resultManHours, 0)
    ) {
      resultProductivity = null;
    }
    return setMathRoundNumber(resultProductivity);
  };

  calculateSumParents = listChildren => {
    const parentsItem = {
      quantity: null,
      productivity: null,
      total_man_days: null,
      plan_man_hours: null,
      plan_result_diff_man_hours: null,
      plan_result_diff_amount: null,
      plan_amount: null,
      result_amount: null,
      result_man_hours: null,
      schedule_man_hours: null,
      plan_productivity: null,
      result_productivity: null,
      plan_result_diff_productivity: null,
    };
    _.forEach(listChildren, child => {
      _.isNull(child.quantity) || (parentsItem.quantity += child.quantity);
      _.isNull(child.total_man_days) ||
        (parentsItem.total_man_days += child.total_man_days);
      _.isNull(child.plan_man_hours) ||
        (parentsItem.plan_man_hours += child.plan_man_hours);
      _.isNull(child.plan_amount) ||
        (parentsItem.plan_amount += child.plan_amount);
      _.isNull(child.result_man_hours) ||
        (parentsItem.result_man_hours += child.result_man_hours);
      _.isNull(child.schedule_man_hours) ||
        (parentsItem.schedule_man_hours += child.schedule_man_hours);
      _.isNull(child.result_amount) ||
        (parentsItem.result_amount += child.result_amount);
    });
    if (
      !_.isNull(parentsItem.total_man_days) &&
      !_.isNull(parentsItem.quantity) &&
      !_.isEqual(parentsItem.total_man_days, 0)
    ) {
      const parentsItemProductivity = setMathRoundNumber(
        +parentsItem.quantity / +parentsItem.total_man_days
      );
      parentsItem.productivity = parentsItemProductivity;
      parentsItem.plan_productivity = parentsItemProductivity;
    }

    _.isNull(parentsItem.result_man_hours) ||
      _.isNull(parentsItem.plan_man_hours) ||
      (parentsItem.plan_result_diff_man_hours = setMathRoundNumber(
        +parentsItem.result_man_hours - +parentsItem.plan_man_hours
      ));

    _.isNull(parentsItem.result_amount) ||
      _.isNull(parentsItem.plan_amount) ||
      (parentsItem.plan_result_diff_amount = setMathRoundNumber(
        +parentsItem.result_amount - +parentsItem.plan_amount
      ));

    _.isNull(parentsItem.result_amount) ||
      _.isNull(parentsItem.result_man_hours) ||
      _.isEqual(+parentsItem.result_man_hours, 0) ||
      (parentsItem.result_productivity = setMathRoundNumber(
        +parentsItem.result_amount / +parentsItem.result_man_hours
      ));

    _.isNull(parentsItem.result_productivity) ||
      _.isNull(parentsItem.plan_productivity) ||
      (parentsItem.plan_result_diff_productivity = setMathRoundNumber(
        +parentsItem.result_productivity - +parentsItem.plan_productivity
      ));
    return parentsItem;
  };

  calculateWhenEditEnded = (flexGrid, cellRangeEvent) => {
    const dataCell = flexGrid.selectedItems[0];
    if (dataCell) {
      switch (cellRangeEvent && cellRangeEvent.col) {
        case INDEX_OF_GRID_COLUMN.start_date:
          dataCell.isMaxDate = true;
          dataCell.isMinDate = false;
          dataCell.plan_work_days =
            dataCell.start_date !== this.startDateOldValue
              ? null
              : dataCell.plan_work_days;
          dataCell.start_date = getValidFormatDate(dataCell.start_date);
          break;
        case INDEX_OF_GRID_COLUMN.end_date:
          dataCell.isMaxDate = false;
          dataCell.isMinDate = true;
          dataCell.plan_work_days =
            dataCell.end_date !== this.endDateOldValue
              ? null
              : dataCell.plan_work_days;
          dataCell.end_date = getValidFormatDate(dataCell.end_date);
          break;
        case INDEX_OF_GRID_COLUMN.result_end_date:
          dataCell.result_end_date = getValidFormatDate(
            dataCell.result_end_date
          );
          break;
        case INDEX_OF_GRID_COLUMN.quantity:
          if (!_.isNull(this.resetValue)) {
            dataCell.quantity = this.resetValue;
          }
          break;
        case INDEX_OF_GRID_COLUMN.productivity:
          if (!_.isNull(this.resetValue)) {
            dataCell.productivity = this.resetValue;
          }
          break;
        case INDEX_OF_GRID_COLUMN.total_man_days:
          if (!_.isNull(this.resetValue)) {
            dataCell.total_man_days = this.resetValue;
          }
          break;
        case INDEX_OF_GRID_COLUMN.result_amount:
          if (!_.isNull(this.resetValue)) {
            dataCell.result_amount = this.resetValue;
          }
          break;
      }

      if (dataCell.start_date === '') {
        dataCell.start_date = null;
      }
      if (dataCell.end_date === '') {
        dataCell.end_date = null;
      }
      if (dataCell.result_end_date === '') {
        dataCell.result_end_date = null;
      }
      if (dataCell.man_day_input_flag) {
        dataCell.productivity = this.calculateEditableColumn(
          dataCell.quantity,
          dataCell.total_man_days
        );
      } else {
        dataCell.total_man_days = this.calculateEditableColumn(
          dataCell.quantity,
          dataCell.productivity
        );
      }
      dataCell.mans_per_day = this.calculateEditableColumn(
        dataCell.total_man_days,
        dataCell.plan_work_days
      );
      const elapsedDays = this.calculateElapsedDays(
        dataCell.start_date,
        dataCell.end_date,
        this.formatDate,
        dataCell.holiday,
        dataCell.current_work_days
      );
      dataCell.plan_man_hours = this.calculatePlanManHours(
        dataCell.total_man_days,
        elapsedDays,
        dataCell.plan_work_days
      );
      dataCell.plan_result_diff_man_hours = this.calculatePlanResultDiffManHours(
        dataCell.result_man_hours,
        dataCell.plan_man_hours
      );
      dataCell.plan_amount = this.calculatePlanAmount(
        elapsedDays,
        dataCell.plan_work_days,
        dataCell.quantity
      );
      if (moment(dataCell.end_date).isBefore(this.formatDate)) {
        dataCell.plan_man_hours = _.isNaN(dataCell.plan_man_hours)
          ? null
          : dataCell.total_man_days;
        dataCell.plan_amount = _.isNaN(dataCell.quantity)
          ? null
          : dataCell.quantity;
        if (_.isEqual(+dataCell.plan_work_days, 0)) {
          dataCell.plan_man_hours = null;
          dataCell.plan_amount = null;
        }
      }
      dataCell.plan_result_diff_amount = this.calculatePlanResultDiffAmount(
        dataCell.result_amount,
        dataCell.plan_amount
      );
      dataCell.plan_productivity = dataCell.productivity;
      dataCell.result_productivity = this.calculateResultProductivity(
        dataCell.result_amount,
        dataCell.result_man_hours
      );
      dataCell.plan_result_diff_productivity = this.calculatePlanResultDiffManHours(
        dataCell.result_productivity,
        dataCell.plan_productivity
      );

      if (
        _.isEmpty(dataCell.start_date) ||
        (_.isEmpty(dataCell.end_date) &&
          _.has(dataCell, 'progress_schedule_calendars'))
      ) {
        delete dataCell.progress_schedule_calendars;
      }

      if (
        moment(dataCell.start_date).isValid() &&
        moment(dataCell.end_date).isValid() &&
        moment(dataCell.start_date).isAfter(moment(dataCell.end_date))
      ) {
        dataCell.plan_work_days = null;
      }
      const listParentsId = _.cloneDeep(dataCell.parentsId);
      this.recursiveCalculateSumChildren(
        listParentsId,
        flexGrid.collectionView.items
      );
      const progressSchedule = this.getProgressScheduleItem(dataCell);
      this.setAutoSizeColumn(dataCell);
      this.setState({ progressSchedule, isCellEditing: false }, () => {
        this.resetValue = null;
        if (
          cellRangeEvent &&
          !_.isNull(dataCell.start_date) &&
          !_.isNull(dataCell.end_date) &&
          moment(dataCell.start_date).isSameOrBefore(dataCell.end_date) &&
          (_.isEqual(cellRangeEvent.col, INDEX_OF_GRID_COLUMN.start_date) ||
            _.isEqual(cellRangeEvent.col, INDEX_OF_GRID_COLUMN.end_date))
        ) {
          this.getScheduleCalendarAndDetail(dataCell, cellRangeEvent.row);
          this.startDateOldValue = dataCell.start_date;
          this.endDateOldValue = dataCell.end_date;
        }
        if (
          moment(dataCell.start_date).isAfter(dataCell.end_date) ||
          _.isNull(dataCell.start_date) ||
          _.isNull(dataCell.end_date)
        ) {
          this.isClickBtnCalendar = false;
        }
      });
    }
  };

  recursiveCalculateSumChildren = (listParentsId, listItems) => {
    if (!_.isUndefined(listParentsId[0])) {
      const item = _.find(listItems, object => {
        let objectId = null;
        if (_.isEqual(object.data_type, DATA_TYPE[0])) {
          objectId = object.field_main_work_type_id;
        } else if (_.isEqual(object.data_type, DATA_TYPE[1])) {
          objectId = object.field_sub_work_type_id;
        } else {
          objectId = object.place_id;
        }
        return _.isEqual(objectId, listParentsId[0]);
      });
      listParentsId.shift();
      if (_.size(item.child)) {
        this.recursiveCalculateSumChildren(listParentsId, item.child);
      }
      const sumValueItem = this.calculateSumParents(item.child);
      if (
        (_.isEqual(item.data_type, DATA_TYPE[0]) &&
          isExistSubItem(this.state.dataTypesUnregistered, item)) ||
        (_.isEqual(item.data_type, DATA_TYPE[this.state.workTypeId + 1]) &&
          !this.state.isWorkType)
      ) {
        item.total_man_days = sumValueItem.total_man_days;
        item.plan_man_hours = sumValueItem.plan_man_hours;
        item.schedule_man_hours = sumValueItem.schedule_man_hours;
        item.result_man_hours = sumValueItem.result_man_hours;
        item.plan_result_diff_man_hours =
          sumValueItem.plan_result_diff_man_hours;
      } else {
        item.quantity = sumValueItem.quantity;
        item.productivity = sumValueItem.productivity;
        item.total_man_days = sumValueItem.total_man_days;
        item.plan_man_hours = sumValueItem.plan_man_hours;
        item.plan_result_diff_man_hours =
          sumValueItem.plan_result_diff_man_hours;
        item.plan_result_diff_amount = sumValueItem.plan_result_diff_amount;
        item.plan_amount = sumValueItem.plan_amount;
        item.result_amount = sumValueItem.result_amount;
        item.result_man_hours = sumValueItem.result_man_hours;
        item.schedule_man_hours = sumValueItem.schedule_man_hours;
        item.plan_productivity = sumValueItem.plan_productivity;
        item.result_productivity = sumValueItem.result_productivity;
        item.plan_result_diff_productivity =
          sumValueItem.plan_result_diff_productivity;
      }
      this.setAutoSizeColumn(item);
    }
  };

  initialDataGrid = grid => {
    this.flexGrid = grid;
    this.setMaxHeightGrid();
    let selRow, selCol;
    grid.scrollPositionChanged.addHandler(flexGrid => {
      this.tooltip.dispose();
      flexGrid.refresh();
    });
    grid.groupCollapsedChanging.addHandler((flexGrid, cellRangeEventArgs) => {
      const { workTypeId } = this.state;
      const selectedItem = flexGrid.selectedItems[0];
      const isCollapse = !workTypeId
        ? !_.isEqual(selectedItem.data_type, DATA_TYPE[0]) &&
          !_.isEqual(selectedItem.data_type, DATA_TYPE[1])
        : !_.isEqual(selectedItem.data_type, DATA_TYPE[workTypeId + 1]) &&
          !_.isEqual(selectedItem.data_type, DATA_TYPE[0]) &&
          !_.isEqual(selectedItem.data_type, DATA_TYPE[1]);
      if (!_.isEmpty(selectedItem.child)) {
        cellRangeEventArgs.cancel = isCollapse;
      }
    });
    grid.groupCollapsedChanged.addHandler(flexGrid => {
      this.tooltip.dispose();
      flexGrid.refresh();
      flexGrid.autoSizeColumns();
    });
    grid.selectionChanged.addHandler(flexGrid => {
      const selectedItem = flexGrid.selectedItems[0];
      if (selectedItem) {
        this.startDateOldValue = selectedItem.start_date;
        this.endDateOldValue = selectedItem.end_date;
        selRow = grid.selection.row;
        selCol = grid.selection.col;
        this.lastItemEdited = selectedItem;
        this.lastRowEdited = selRow;
        this.lastColEdited = selCol;
        flexGrid.collectionView.commitEdit();
        if (this.gridSelectionFlag) {
          this.setIsReadOnlyColumn(flexGrid);
        }
        if (this.isClickBtnCalendar) {
          this.handleOpenCalendar(
            this.lastItemEdited,
            this.lastRowEdited,
            this.lastColEdited
          );
        }
      }
    });
    this.enableQuickEditSupportForEditor(grid);
    grid.hostElement.addEventListener(
      'keydown',
      pointerEvents => {
        this.setIsReadOnlyColumn(grid);
        pointerEvents = pointerEvents || window.event;

        if (grid._edtHdl._fullEdit) {
          return;
        }

        if (
          _.isEqual(selCol, INDEX_OF_GRID_COLUMN.start_date) ||
          _.isEqual(selCol, INDEX_OF_GRID_COLUMN.end_date) ||
          _.isEqual(selCol, INDEX_OF_GRID_COLUMN.result_end_date)
        ) {
          if (
            _.isEqual(pointerEvents.keyCode, wjCore.Key.Up) &&
            grid.rows[selRow - 1]
          ) {
            let backRow;
            const listParentId = grid.rows[selRow - 1].dataItem.listParentsId;
            if (
              _.isEqual(grid.rows[selRow - 1].visibleIndex, IS_DISABLE_ROW) &&
              !_.isEqual(grid.rows[selRow].visibleIndex, IS_DISABLE_ROW) &&
              _.isEqual(grid.rows[selRow].isReadOnly, false) &&
              (!_.isEmpty(listParentId) || !_.isUndefined(listParentId))
            ) {
              backRow = this.setPositionHasColapse(listParentId, selRow);
            } else if (
              !_.isEqual(grid.rows[selRow - 1].visibleIndex, IS_DISABLE_ROW)
            ) {
              backRow = selRow - 1;
            }
            if (!_.isUndefined(backRow)) {
              pointerEvents.preventDefault();
              pointerEvents.stopImmediatePropagation();
              const upCellIndex =
                selRow != FIRST_ROW_OF_TABLE ? backRow : FIRST_ROW_OF_TABLE;
              grid.select(upCellIndex, selCol);
            }
          } else if (
            _.isEqual(pointerEvents.keyCode, wjCore.Key.Down) &&
            grid.rows[selRow + 1] &&
            !_.isEqual(grid.rows[selRow + 1].visibleIndex, IS_DISABLE_ROW)
          ) {
            pointerEvents.preventDefault();
            pointerEvents.stopImmediatePropagation();
            const maxRow = grid.rows.length - 1;
            const nextRow = selRow + 1;
            const downCellIndex = selRow != maxRow ? nextRow : maxRow;
            grid.select(downCellIndex, selCol);
          }
        }
      },
      true
    );
    setDisplayTab(grid, this.isPlanTagFlg);
    grid.mergeManager = new CustomMergeManager();
    this.flexGrid.keyActionEnter = wjGrid.KeyAction.CycleEditable;
    const oldFunc = wjGrid.CellFactory.prototype.updateCell;
    wjGrid.CellFactory.prototype.updateCell = function(e, t, i, o, n, r) {
      oldFunc.call(this, e, t, i, o, n, r);

      const l = e.grid,
        a = e.rows,
        u = e.columns,
        c = a[t],
        d = u[i],
        v = e.cellType,
        E = wjGrid.CellType;
      let P = l._getBindingColumn(e, t, d),
        Q = 0 != r && P ? e.getCellData(t, i, !1) : null;

      if ((v == E.Cell || v == E.RowHeader) && l._getShowErrors()) {
        let Re = '';
        !1 === r && P && (Q = e.getCellData(t, i, !1));
        const Ee = a[t].dataItem;
        Re =
          P.binding && Ee && P.getIsRequired(c) && (null == Q || '' === Q)
            ? l._edtHdl._getRequiredMsg()
            : l._getError(e, t, i, !1);
        l._edtHdl._setCellError(o, Re);
      }
    };
  };

  setPositionHasColapse = (listParentId, selRow) => {
    let backRow;
    if (_.isEqual(listParentId.length, EXIST_MAIN_SUB_WORK)) {
      backRow = selRow - this.getIndexOfBackRow(listParentId) - 1;
    }
    return backRow;
  };

  getIndexOfBackRow = listParentId => {
    const mainWork = this.listProgressSchedulesAxis.filter(obj =>
      _.isEqual(obj.field_main_work_type_id, listParentId[0])
    );
    const subWork = mainWork[0].sub_works_or_places.filter(obj =>
      _.isEqual(obj.field_sub_work_type_id, listParentId[1])
    );
    return subWork[0].work_places.length;
  };

  enableQuickEditSupportForEditor = grid => {
    grid.prepareCellForEdit.addHandler((flexgrid, args) => {
      const evt = args.data;
      if (evt.type === 'keypress' && evt.key !== 'F2') {
        grid._edtHdl._fullEdit = false;
      }
    });
  };

  resizedColumn = (flexGrid, cellRangeEventArgs) => {
    if (
      _.filter(this.listColumnResize, object =>
        _.isEqual(object.numberOfColumn, cellRangeEventArgs.col)
      ).length > 0
    ) {
      const index = _.findIndex(this.listColumnResize, object => {
        return _.isEqual(object.numberOfColumn, cellRangeEventArgs.col);
      });
      this.listColumnResize[index].widthOfColumn =
        cellRangeEventArgs.panel.columns[cellRangeEventArgs.col].width;
    } else {
      if (_.includes(LIST_COLUMN_RESIZE, cellRangeEventArgs.col)) {
        this.listColumnResize.push({
          numberOfColumn: cellRangeEventArgs.col,
          widthOfColumn:
            cellRangeEventArgs.panel.columns[cellRangeEventArgs.col].width,
        });
      }
    }
  };

  getTextWidth = text => {
    const fontFamily = window
      .getComputedStyle(document.body)
      .getPropertyValue('font-family');
    const textStyles = {
      fontSize: FONT_SIZE,
      fontFamily,
    };
    return this.textWidth(text, textStyles);
  };

  checkConditionResizeColumn = (column, sizeColumn) => {
    return (
      _.filter(
        this.listColumnResize,
        item =>
          _.isEqual(item.numberOfColumn, column) &&
          item.widthOfColumn > sizeColumn
      ).length > 0
    );
  };

  setAutoSizeColumn = dataCell => {
    this.checkConditionResizeColumn(
      INDEX_OF_GRID_COLUMN.quantity,
      this.getTextWidth(
        `${this.formatNumber(dataCell.quantity)} ${dataCell.unit_name}`
      ) + PADDING_TO_LEFT_RIGHT
    ) === true
      ? ''
      : this.flexGrid.autoSizeColumn(INDEX_OF_GRID_COLUMN.quantity);
    this.checkConditionResizeColumn(
      INDEX_OF_GRID_COLUMN.productivity,
      this.getTextWidth(
        `${this.formatNumber(dataCell.productivity)} ${dataCell.unit_name}/人`
      ) + PADDING_TO_LEFT_RIGHT
    ) === true
      ? ''
      : this.flexGrid.autoSizeColumn(INDEX_OF_GRID_COLUMN.productivity);
    this.checkConditionResizeColumn(
      INDEX_OF_GRID_COLUMN.total_man_days,
      this.getTextWidth(`${this.formatNumber(dataCell.total_man_days)} 人`) +
        PADDING_TO_LEFT_RIGHT
    ) === true
      ? ''
      : this.flexGrid.autoSizeColumn(INDEX_OF_GRID_COLUMN.total_man_days);
    this.checkConditionResizeColumn(
      INDEX_OF_GRID_COLUMN.result_amount,
      this.getTextWidth(
        `${this.formatNumber(dataCell.result_amount)} ${dataCell.unit_name}`
      ) + PADDING_TO_LEFT_RIGHT
    ) === true
      ? ''
      : this.flexGrid.autoSizeColumn(INDEX_OF_GRID_COLUMN.result_amount);

    this.flexGrid.autoSizeColumns(
      INDEX_OF_GRID_COLUMN.start_date,
      INDEX_OF_GRID_COLUMN.plan_work_days
    );
    this.flexGrid.autoSizeColumns(
      INDEX_OF_GRID_COLUMN.mans_per_day,
      INDEX_OF_GRID_COLUMN.plan_amount
    );
    this.flexGrid.autoSizeColumns(
      INDEX_OF_GRID_COLUMN.plan_result_diff_amount,
      INDEX_OF_GRID_COLUMN.plan_result_diff_productivity
    );
  };

  getSpan = () => {
    const span = document.createElement('span');
    span.style.position = 'fixed';
    span.style.visibility = 'hidden';
    document.body.appendChild(span);
    return span;
  };

  textWidth = (text, css) => {
    const span = this.getSpan();
    Object.assign(span.style, css || {});
    span.innerText = text;
    const textWidth = Math.round(span.getBoundingClientRect().width);
    span.remove();
    return textWidth;
  };

  cellEditEnding = (flexGrid, cellEditEndingEvent) => {
    const colEdit = [
      INDEX_OF_GRID_COLUMN.quantity,
      INDEX_OF_GRID_COLUMN.productivity,
      INDEX_OF_GRID_COLUMN.total_man_days,
      INDEX_OF_GRID_COLUMN.result_amount,
    ];
    const value =
      !_.isNull(flexGrid.activeEditor) && flexGrid.activeEditor.value;
    if (value < 0 && _.includes(colEdit, cellEditEndingEvent.col)) {
      this.resetValue = 0;
    } else if (
      cellEditEndingEvent.col === INDEX_OF_GRID_COLUMN.start_date ||
      cellEditEndingEvent.col === INDEX_OF_GRID_COLUMN.end_date ||
      cellEditEndingEvent.col === INDEX_OF_GRID_COLUMN.result_end_date
    ) {
      const columnName = flexGrid.columns[cellEditEndingEvent.col].binding;
      const currentValue = flexGrid.selectedItems[0][columnName];
      const valueDate = getValidFormatDate(value);
      // cancel edit if value not change empty or newValue is invalid
      if ((!value && !currentValue) || (value && !valueDate)) {
        cellEditEndingEvent.cancel = true;
      }
    }
  };

  cellEditEnded = (flexGrid, cellRangeEvent) => {
    this.calculateWhenEditEnded(flexGrid, cellRangeEvent);
    this.tooltip.dispose();
  };

  pasting = (flexGrid, cellRangeEventArgs) => {
    flexGrid.refresh();
    if (
      !_.isEqual(cellRangeEventArgs.range.col, cellRangeEventArgs.range.col2) ||
      !_.isEqual(cellRangeEventArgs.range.row, cellRangeEventArgs.range.row2)
    ) {
      cellRangeEventArgs.cancel = true;
    }
  };

  pastingCell = (flexGrid, cellRangeEvent) => {
    if (
      cellRangeEvent.col === INDEX_OF_GRID_COLUMN.start_date ||
      cellRangeEvent.col === INDEX_OF_GRID_COLUMN.end_date ||
      cellRangeEvent.col === INDEX_OF_GRID_COLUMN.result_end_date
    ) {
      if (
        !moment(
          cellRangeEvent.data,
          DATE_TIME_FORMAT.slashDateFormat,
          true
        ).isValid()
      ) {
        cellRangeEvent.cancel = true;
      }
    } else {
      if (
        !PATTERN_NUMBER.test(cellRangeEvent._data) ||
        +cellRangeEvent.data < 0
      ) {
        cellRangeEvent.cancel = true;
      }
    }
  };

  pastedCell = (flexGrid, cellRangeEvent) => {
    const { listCellEdited } = this.state;
    const id = _.toNumber(`${cellRangeEvent.col}${cellRangeEvent.row}`);
    this.calculateWhenEditEnded(flexGrid, cellRangeEvent);
    flexGrid.collectionView.commitEdit();
    this.tooltip.dispose();
    const findItem = _.find(listCellEdited, item => {
      return item.id === id;
    });
    if (_.isUndefined(findItem)) {
      this.setState({
        listCellEdited: [
          ...listCellEdited,
          {
            id,
            isEdited: false,
          },
        ],
      });
    }
  };

  beginningEdit = (flexGrid, cellRangeEvent) => {
    const id = _.toNumber(`${cellRangeEvent.col}${cellRangeEvent.row}`);
    const { listCellEdited } = this.state;
    const findItem = _.find(listCellEdited, item => {
      return item.id === id;
    });
    if (_.isUndefined(findItem)) {
      this.setState({
        listCellEdited: [
          ...listCellEdited,
          {
            id,
            isEdited: false,
          },
        ],
        isCellEditing: true,
      });
    }
  };

  lostFocus = () => {
    if (!this.isCopiedCellFlg) {
      this.flexGrid.select(
        new wjGrid.CellRange(IS_DISABLE_ROW, IS_DISABLE_ROW),
        false
      );
    } else {
      this.isCopiedCellFlg = false;
    }
  };

  copied = () => {
    this.isCopiedCellFlg = true;
  };

  render() {
    const {
      countTotalInvalidCell,
      isShowPopupError,
      messageError,
      isTableLoading,
      isShowWorkDatesDialog,
      currentProgressSchedule,
      callApiFlag,
      isCellEditing,
    } = this.state;
    const titleBrowser = !this.isPlanTagFlg
      ? TITLE_BROWSER_PROGRESS.progressPlan
      : TITLE_BROWSER_PROGRESS.progressResult;
    const titleHeader = !this.isPlanTagFlg
      ? HEADER_CONSTANTS_PROGRESS.progressPlan
      : HEADER_CONSTANTS_PROGRESS.progressResult;
    return (
      <div className='master-slide-view show ProgressSchedule ProgressScheduleEdit'>
        <Helmet>
          <link rel='icon' href={IconProgress} />
          <title>{titleBrowser}</title>
        </Helmet>
        <div className='master-slide-view__view'>
          <MasterPageHeader title={titleHeader} disableHelpMenu />
          <div id='infinityscroll-target' className='master-slide-view__table'>
            <div className='ProgressScheduleEdit__header'>
              <HeaderMenu
                confirmUpdate={this.updateProgressSchedules}
                goBack={this.events.dialog.goBack}
                isDisabledUpdate={!!countTotalInvalidCell || isCellEditing}
              />
              {countTotalInvalidCell > 0 && (
                <div className='ProgressScheduleEdit__header--error-message'>
                  エラーが{countTotalInvalidCell}
                  件あります。入力内容を確認してください。
                </div>
              )}
            </div>
            <div className='ProgressScheduleEdit__note'>
              <div className='ProgressScheduleEdit__note--common bg-green' />
              <span className='ProgressScheduleEdit__note--text'>
                編集可能な項目
              </span>
              <div className='ProgressScheduleEdit__note--common bg-yellow' />
              <span className='ProgressScheduleEdit__note--text'>
                編集後の項目
              </span>
            </div>
            <FlexGrid
              columnGroups={this.columnGroupInit}
              itemsSource={this.listItems}
              frozenColumns={1}
              selectionMode={'Cell'}
              allowSorting={false}
              allowDragging={0}
              autoGenerateColumns={false}
              validateEdits={false}
              quickAutoSize={true}
              childItemsPath={this.childItemsPath}
              refreshed={this.refreshed}
              formatItem={this.formatItem}
              initialized={this.initialDataGrid}
              cellEditEnded={this.cellEditEnded}
              pasting={this.pasting}
              pastingCell={this.pastingCell}
              pastedCell={this.pastedCell}
              copied={this.copied}
              cellEditEnding={this.cellEditEnding}
              resizedColumn={this.resizedColumn}
              beginningEdit={this.beginningEdit}
              lostFocus={this.lostFocus}
            />
            {isTableLoading && <div className='indicator' />}
          </div>
          <Confirmation
            rootClassName='ProgressErrorDialog'
            visible={isShowPopupError}
            message={messageError}
            title={messageUtility.getMessage('E-001-402')}
            multilineText={true}
            cancelButtonText={messageUtility.getMessage('I-000-017')}
            confirmButtonText={messageUtility.getMessage('I-000-180')}
            onCancel={() => {
              this.setState({
                isShowPopupError: false,
              });
            }}
            onConfirm={() => window.location.reload()}
          />
          {isShowWorkDatesDialog && (
            <ProgressWorkDatesDialog
              visible={isShowWorkDatesDialog}
              onClose={() =>
                this.setState({
                  isShowWorkDatesDialog: false,
                  callApiFlag: false,
                })
              }
              progressScheduleItem={currentProgressSchedule}
              getWorkDays={this.getWorkDays}
              callApiFlag={callApiFlag}
            />
          )}
        </div>
      </div>
    );
  }
}

class MaxNumberValidator {
  constructor(maxValue, message = null) {
    this.maxValue = maxValue;
    this.message = message;
  }
  validate(displayName, value) {
    if (value > this.maxValue || _.isNaN(value)) {
      return wjCore.format(`${displayName}: ${this.message}`);
    }
  }
}

class MaxValueDateValidator {
  constructor(
    isMaxDate = true,
    message = '開始日には、終了日より前の日付を指定してください。'
  ) {
    this.isMaxDate = isMaxDate;
    this.message = message;
  }
  validate(value, maxValue) {
    if (maxValue && moment(value).isAfter(maxValue)) {
      return wjCore.format(this.message);
    }
    return '';
  }
}

class MinValueDateValidator {
  constructor(
    isMinDate = true,
    message = '終了日には、開始日より後の日付を指定してください。'
  ) {
    this.isMinDate = isMinDate;
    this.message = message;
  }
  validate(value, minDate) {
    if (minDate && moment(value).isBefore(minDate)) {
      return wjCore.format(
        '終了日には、開始日より後の日付を指定してください。'
      );
    }
    return '';
  }
}

class CustomMergeManager extends wjGrid.MergeManager {
  getMergedRange(panel) {
    if (panel.cellType === wjGrid.CellType.TopLeft) {
      return new wjGrid.CellRange(
        0,
        0,
        panel.rows.length - 1,
        panel.columns.length - 1
      );
    } else {
      return wjGrid.MergeManager.prototype.getMergedRange.apply(
        this,
        arguments
      );
    }
  }
}

const getDaysDiff = (
  startDate,
  endDate,
  dateFormat = DATE_TIME_FORMAT.hyphenDateFormat
) => {
  const getDateAsArray = date => {
    return moment(date.split(/\D+/), dateFormat);
  };
  return Math.abs(
    getDateAsArray(endDate).diff(getDateAsArray(startDate), 'days') + 1
  );
};



// WEBPACK FOOTER //
// ./src/pages/ProgressScheduleEdit.jsx